import React, { useEffect, useState } from "react";
import styles from "./login.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { ArrowIcon, BackArrowIcon, LogoIcon } from "../../../svg";
import { useDispatch } from "react-redux";
import Toastify from "../../helper/Toastify";
import { unwrapResult } from "@reduxjs/toolkit";
import { verifyLoginOtp } from "../../redux/loginSlice";

const LoginOtpVerification = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const email =
    location?.state?.email || location?.state?.values?.email || null;
  const callbackUrl =
    location?.state?.callbackUrl || null;

  const [loading, setLoading] = useState(false);
  const [emailOtp, setEmailOtp] = useState("");
  const [mobileOtp, setMobileOtp] = useState("");
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!email) {
      // If user refreshed the page and state is missing
      navigate("/login");
    }
  }, [email, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (emailOtp.length !== 4 || mobileOtp.length !== 6) {
      Toastify.error("Enter valid 4-digit email OTP and 6-digit mobile OTP");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const resultAction = await dispatch(
        verifyLoginOtp({ email, otp: emailOtp, mobileOtp })
      );
      unwrapResult(resultAction);

      if (callbackUrl) navigate(callbackUrl);
      else navigate("/courses/Courses");
    } catch (err) {
      setError(err?.message || "OTP verification failed");
      Toastify.error(err?.message || "OTP verification failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.main}>
        <div className={styles.mainContainer}>
          <LogoIcon />
        </div>
        <div className={styles.login}>
          <div className={styles.mobileViewLogin}>
            <div className={styles.mobileLogoStyle}>
              <h3>KINGSTER</h3>
            </div>
          </div>

          <div className={styles.content}>
            <div
              onClick={() => navigate("/login")}
              stylle={{
                marginTop: "10px",
                display: "flex",
                alignItems: "center",
              }}
              className={styles.backArrowStyle}
            >
              <BackArrowIcon />
              <span className={styles.backToLogin}>Back</span>
            </div>

            <h3 style={{ marginTop: 40 }} className={styles.forgotPassword}>
              Verify Login
            </h3>
            <p style={{ marginTop: 40 }}>
              Enter the OTP sent to your email and mobile number.
            </p>

            {error && <div className={styles.errorText}>{error}</div>}

            <form onSubmit={handleSubmit}>
              <div style={{ marginTop: 20 }}>
                <label className={styles.label}>Email OTP</label>
                <div className={styles.inputbox}>
                  <input
                    type="text"
                    value={emailOtp}
                    placeholder="Enter 4 digits email OTP"
                    name="emailOtp"
                    onChange={(e) => {
                      const input = e.target.value;
                      if (/^\d{0,4}$/.test(input)) setEmailOtp(input);
                    }}
                  />
                </div>
              </div>

              <div style={{ marginTop: 20 }}>
                <label className={styles.label}>Mobile OTP</label>
                <div className={styles.inputbox}>
                  <input
                    type="text"
                    value={mobileOtp}
                    placeholder="Enter 6 digits mobile OTP"
                    name="mobileOtp"
                    onChange={(e) => {
                      const input = e.target.value;
                      if (/^\d{0,6}$/.test(input)) setMobileOtp(input);
                    }}
                  />
                </div>
              </div>

              <div className={styles.google}>
                <div
                  className={styles.saveButtonStyle}
                  onClick={handleSubmit}
                  disabled={loading}
                  style={{ marginTop: 30 }}
                >
                  {loading ? (
                    <CircularProgress
                      size={25}
                      thickness={4.5}
                      sx={{ color: "#fff" }}
                    />
                  ) : (
                    "Verify"
                  )}
                  <ArrowIcon />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginOtpVerification;

